export const base_url = "http://reachlovenheal.com:8080";

export async function getBlogs() {
  try {
    const response = await fetch(`${base_url}/blogs?isSorted=true&sortOrder=DESC&sortBy=createdDate`);
    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Fetch error:", err);
    return {};
  }
}

export async function getBlog(blogId) {
  try {
    const response = await fetch(`${base_url}/blogs/${blogId}`);
    const data = await response.json();
    return data;
  } catch (err) {
    console.error(err);
    return {};
  }
}
